import * as React from 'react';
import './faqPane.module.scss';
import { LoaderRow } from '../../atoms/layout/LoaderRow';
import { FaqCategoryView } from '../../molecules/faqs/FaqCategoryView';
import { action, observable, makeObservable } from 'mobx';
import { RemoteResourceV3, updateRemoteResourceV3 } from '../../../../commonv3/api/RemoteResourceV3';
import { FaqCategoryShowView } from '../../../types/faqs';
import { observer } from 'mobx-react';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { FaqApis } from '../../../apis/faqs';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import { V3Routes } from '../../../routes';

type Props = {
  showTrialCta?: boolean;
};

export const FaqPane = observer(
  class FaqPane extends React.Component<Props> {
    categories: RemoteResourceV3<FaqCategoryShowView[]> = RemoteResourceV3.loading();

    constructor(props: Props) {
      super(props);

      makeObservable(this, {
        categories: observable,
        init: action.bound,
      });
    }

    componentDidMount(): void {
      this.init();
    }

    async init() {
      await updateRemoteResourceV3(
        this.categories,
        (v) => (this.categories = v),
        () => FaqApis.findAll()
      );
    }

    render() {
      const { showTrialCta = true } = this.props;
      return (
        <div>
          <div id="faq-page" styleName="faq-page">
            <div>
              <div styleName="index-section">
                <h3 styleName="section-sub-header">目次</h3>
                <div className="index-contents">
                  {this.categories.loading && <LoaderRow />}
                  {this.categories.getOrElse([]).map((category) => (
                    <div key={category.id}>
                      <div styleName="index-category-wrapper">
                        <span styleName="index-title-circle" />
                        <a href={'#c' + category.id} styleName="index-category-title-link">
                          <h4 styleName="index-category-title">{category.title}</h4>
                        </a>
                      </div>
                      <div styleName="index-title-wrapper">
                        {category.faqs.map((q) => (
                          <div key={q.id} styleName="index-title-li">
                            <span styleName="index-question-circle" />
                            <a href={'#' + q.id}>
                              <p styleName="index-question-title">{q.question}</p>
                            </a>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div styleName="faq-list">
                {this.categories.loading && <LoaderRow />}
                {this.categories.getOrElse([]).map((faq) => (
                  <FaqCategoryView key={faq.id} category={faq} />
                ))}
              </div>
            </div>
          </div>
          <div styleName="contact-section">
            <div className="page-content">
              {showTrialCta && (
                <div styleName="buttons">
                  <Button
                    styleName="button"
                    type="primary"
                    size="l"
                    onClick={() => GlobalStatesV3.routing.push(V3Routes.trial())}
                  >
                    体験レッスンを予約する
                  </Button>
                </div>
              )}
              <p styleName="contact-body">
                FAQをご覧いただいても解決されない場合は、
                <a href="https://line.me/R/ti/p/%40xzy6836c">SHEの公式LINE＠</a>
                へお問い合わせください。
              </p>
            </div>
          </div>
        </div>
      );
    }
  }
);
